import { createApi } from '@reduxjs/toolkit/query/react';
import { CUSTOMER_ORDER } from '@utils/constants/customer-order.constants';
import { baseQueryWithReauth } from '@states/auth/auth.api';

export const customerOrderApi = createApi({
    reducerPath: 'customerOrderApi',
    tagTypes: ['CustomerOrder'],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getOneCustomerOrder: builder.query<
            any,
            { customer_order_id: string | number }
        >({
            query: ({ customer_order_id }) => ({
                url: `${CUSTOMER_ORDER.GET_ONE}${customer_order_id}`,
            }),
        }),
        getAllCustomerOrders: builder.query<
            any,
            {
                page?: number;
                limit?: number;
                customer_name?: string;
                customer_order_code?: string;
                customer_id?: string | number;
                payment_type_id?: string | number;
                business_unit_id?: string | number;
                from_date?: Date | string;
                to_date?: Date | string;
                status?: string;
                way_id?: any;
                region_id?: any;
            }
        >({
            query: ({
                page = 1,
                limit = 10,
                customer_name,
                customer_order_code,
                customer_id,
                payment_type_id,
                business_unit_id,
                from_date,
                to_date,
                status,
                way_id,
                region_id,
            }) => {
                const queryParams: any = {
                    url: CUSTOMER_ORDER.GET_ALL,
                    params: { page, limit },
                };

                if (way_id) {
                    queryParams.params.way_id = way_id;
                }
                if (region_id) {
                    queryParams.params.region_id = region_id;
                }
                if (customer_name) {
                    queryParams.params.customer_name = customer_name;
                }
                if (customer_order_code) {
                    queryParams.params.customer_order_code = customer_order_code;
                }
                if (customer_id) {
                    queryParams.params.customer_id = customer_id;
                }
                if (payment_type_id) {
                    queryParams.params.payment_type_id = payment_type_id;
                }
                if (business_unit_id) {
                    queryParams.params.business_unit_id = business_unit_id;
                }
                if (from_date) {
                    queryParams.params.from_date = from_date;
                }
                if (to_date) {
                    queryParams.params.to_date = to_date;
                }
                if (status) {
                    queryParams.params.status = status;
                }

                return queryParams;
            },
        }),
    }),
    keepUnusedDataFor: 0,
});

export const {
    useGetOneCustomerOrderQuery,
    useLazyGetOneCustomerOrderQuery,
    useGetAllCustomerOrdersQuery,
} = customerOrderApi;
